import _ from "lodash";
import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";
import images from "@/utils/images";
import { RATING_OPTION_LABEL_MAP } from "@/constants/rating";
import { TextArea } from "@/components/UI/StyledInput";

import { BehavioralGoalsRating } from "../../components/BehavioralGoalsRating";

export const BehavioralGoals = (props) => {
  const { editable, editHandler, note, profileView } = props;

  let goalsObjectivesProgress = note.content.goals_objectives_progress;

  const [isEditing, setIsEditing] = React.useState(false);
  const [editCopy, setEditCopy] = React.useState(_.cloneDeep(goalsObjectivesProgress));

  const handleEditCopyChange = (e, index, key, isNumber = false) => {
    let editCopyClone = _.cloneDeep(editCopy);

    editCopyClone[index][key] = isNumber ? parseInt(e.target.value) : e.target.value;
    setEditCopy(editCopyClone);

    if (editHandler) {
      editHandler("goals_objectives_progress", editCopyClone);
    }
  };

  let content = (
    <>
      <div className="row mx-1 px-1">
        <div className="col-lg-5">
          <p className="clr-sec tw:font-bold">Goals, Objectives, & Progress Towards Goals</p>
        </div>

        <div className="col-lg-3 tw:font-bold">
          <p className="clr-sec tw:font-bold">Actions</p>
        </div>

        <div className="col-lg-4 tw:font-bold">
          <div className="d-flex justify-content-between">
            <p className="clr-sec"> Plan</p>
            {editable && !isEditing && (
              <img
                alt="Edit Goals, Objectives, Progress"
                onClick={() => setIsEditing((curr) => !curr)}
                src={images("./icons/edit-2.svg")}
                style={{
                  height: "30px",
                  width: "30px",
                }}
              />
            )}

            {editable && isEditing && (
              <img
                alt="Save"
                onClick={() => {
                  setIsEditing((curr) => !curr);
                }}
                src={images("./icons/save.svg")}
                style={{
                  height: "30px",
                  width: "30px",
                }}
              />
            )}
          </div>
        </div>
      </div>

      {goalsObjectivesProgress.map((progress, index) => {
        let style = { minHeight: 50 };

        if (index !== goalsObjectivesProgress.length - 1) {
          style.borderBottom = "1px  solid #DAE6EC";
        } else if (index === goalsObjectivesProgress.length - 1 && profileView) {
          style.borderBottom = "2px  solid #DAE6EC";
        }

        return (
          <div className="row mt-1 mx-1 px-1" key={progress.label + index} style={style}>
            <div className="col-lg-5">
              <div>
                {index + 1}. {progress.label}
              </div>

              <div>
                <div className="col-12 d-flex justify-content-start">
                  {Object.values(RATING_OPTION_LABEL_MAP).map((optionLabel, labelIndex) => (
                    <div
                      className="w-25 fs-10 text-center tw:font-bold"
                      key={optionLabel + labelIndex}
                    >
                      <div className="m-auto">{optionLabel}</div>
                    </div>
                  ))}
                </div>

                <BehavioralGoalsRating
                  isEditing={editable}
                  onClick={(e) => handleEditCopyChange(e, index, "answer", true)}
                  optionLabelMap={RATING_OPTION_LABEL_MAP}
                  progress={!editable ? progress : editCopy[index]}
                />
              </div>
            </div>

            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.actions}</p>
              ) : (
                <TextArea
                  onChange={(e) => handleEditCopyChange(e, index, "actions")}
                  value={editCopy[index].actions}
                />
              )}
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.plan}</p>
              ) : (
                <TextArea
                  onChange={(e) => handleEditCopyChange(e, index, "plan")}
                  value={editCopy[index].plan}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );

  let desktopContent;

  if (!profileView) {
    desktopContent = (
      <CardSecondary className="mx-auto px-3 py-3 mt-3 d-none d-md-none d-lg-block">
        {content}
      </CardSecondary>
    );
  } else {
    desktopContent = <div>{content}</div>;
  }

  let mobileContent = (
    <div className="d-block d-md-block d-lg-none mt-3">
      <div className="d-flex justify-content-between">
        <p className="cmt-3 clr-sec tw:font-bold">Goals, Objectives, & Progress Towards Goals</p>
        {editable && !isEditing && (
          <img
            alt="Edit Goals, Objectives, Progress"
            onClick={() => setIsEditing((curr) => !curr)}
            src={images("./icons/edit-2.svg")}
            style={{
              height: "30px",
              width: "30px",
            }}
          />
        )}
        {editable && isEditing && (
          <img
            alt="Save"
            onClick={() => {
              setIsEditing((curr) => !curr);
            }}
            src={images("./icons/save.svg")}
            style={{
              height: "30px",
              width: "30px",
            }}
          />
        )}
      </div>
      {goalsObjectivesProgress.map((progress, index) => {
        return (
          <CardSecondary className="mx-auto mt-2 px-3 py-3 d-block" key={progress.label + index}>
            <div className="col-lg-3 tw:font-bold">
              <p className="clr-sec tw:font-bold">Goal</p>
            </div>
            <div>
              {index + 1}. {progress.label}
            </div>
            <BehavioralGoalsRating
              isEditing={isEditing}
              onClick={(e) => handleEditCopyChange(e, index, "answer", true)}
              optionLabelMap={RATING_OPTION_LABEL_MAP}
              progress={progress}
            />

            <div className="col-lg-3 tw:font-bold">
              <p className="clr-sec tw:font-bold">Actions</p>
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.actions}</p>
              ) : (
                <TextArea
                  onChange={(e) => handleEditCopyChange(e, index, "actions")}
                  value={editCopy[index].actions}
                />
              )}
            </div>

            <div className="col-lg-4 tw:font-bold">
              <p className="clr-sec tw:font-bold">Plan</p>
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.plan}</p>
              ) : (
                <TextArea
                  onChange={(e) => handleEditCopyChange(e, index, "plan")}
                  value={editCopy[index].plan}
                />
              )}
            </div>
          </CardSecondary>
        );
      })}
    </div>
  );

  return (
    <>
      {desktopContent}
      <div className="print-class">{mobileContent}</div>
    </>
  );
};
